import SEO from '../components/SEO';

export default function RoadmapPage() {
  return (
    <div className="flex-1 bg-white py-12">
      <SEO
        title="Product Roadmap | Waybook"
        description="Explore Waybook's product roadmap and upcoming features. See what we're building to make travel planning easier and more enjoyable."
        keywords="product roadmap, upcoming features, future updates, development plans"
        canonicalUrl="https://www.waybook.me/roadmap"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'Product Roadmap',
          description: 'Waybook product roadmap and upcoming features',
          url: 'https://www.waybook.me/roadmap'
        }}
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold mb-8">Product Roadmap</h1>
        <p className="text-gray-600 mb-12">
          Here's what we're working on to make Waybook the best travel planning app.
        </p>
        
        <div className="space-y-12">
          <section>
            <div className="flex items-center mb-4">
              <span className="bg-black text-waybook-green px-3 py-1 text-sm font-semibold mr-3">
                IN PROGRESS
              </span>
              <h2 className="text-2xl font-bold">Q2 2026</h2>
            </div>
            <ul className="space-y-3 ml-4 border-l-2 border-gray-200 pl-6">
              <li className="text-gray-700">
                <strong>Mobile App Launch</strong> - iOS and Android apps with core features
              </li>
              <li className="text-gray-700">
                <strong>Collaborative Planning</strong> - Share and plan trips with friends
              </li>
              <li className="text-gray-700">
                <strong>Offline Mode</strong> - Access your trip plans without internet
              </li>
            </ul>
          </section>

          <section>
            <div className="flex items-center mb-4">
              <span className="bg-gray-200 text-gray-700 px-3 py-1 text-sm font-semibold mr-3">
                PLANNED
              </span>
              <h2 className="text-2xl font-bold">Q3 2026</h2>
            </div>
            <ul className="space-y-3 ml-4 border-l-2 border-gray-200 pl-6">
              <li className="text-gray-700">
                <strong>AI Trip Assistant</strong> - Get personalized recommendations
              </li>
              <li className="text-gray-700">
                <strong>Budget Tracking</strong> - Monitor and manage trip expenses
              </li>
              <li className="text-gray-700">
                <strong>Route Optimization</strong> - Find the best paths between destinations
              </li>
            </ul>
          </section>

          <section>
            <div className="flex items-center mb-4">
              <span className="bg-gray-200 text-gray-700 px-3 py-1 text-sm font-semibold mr-3">
                PLANNED
              </span>
              <h2 className="text-2xl font-bold">Q4 2026</h2>
            </div>
            <ul className="space-y-3 ml-4 border-l-2 border-gray-200 pl-6">
              <li className="text-gray-700">
                <strong>Social Features</strong> - Follow travelers and share experiences
              </li>
              <li className="text-gray-700">
                <strong>Travel Marketplace</strong> - Book hotels, tours, and activities
              </li>
              <li className="text-gray-700">
                <strong>Photo Albums</strong> - Create beautiful trip photo collections
              </li>
            </ul>
          </section>
        </div>

        <div className="mt-12 p-6 bg-gray-50 border border-gray-200">
          <h3 className="text-lg font-semibold mb-2">Have a feature request?</h3>
          <p className="text-gray-700">
            We'd love to hear your ideas! Send your suggestions to feedback@waybook.com
          </p>
        </div>
      </div>
    </div>
  );
}
